// Shim for @vue/composition-api to use Vue 2.7 built-in Composition API
// In Vue 2.7, Composition API is built-in and exported as named exports from 'vue'
// Export Vue as default for compatibility with plugins that expect it
import Vue from 'vue';

export {
  ref,
  reactive,
  readonly,
  computed,
  watch,
  watchEffect,
  provide,
  inject,
  onBeforeMount,
  onMounted,
  onBeforeUpdate,
  onUpdated,
  onBeforeUnmount,
  onUnmounted,
  onErrorCaptured,
  onRenderTracked,
  onRenderTriggered,
  getCurrentInstance,
  h,
  toRefs,
  defineComponent,
  nextTick,
  set,
  del,
  useCssModule,
  version,
} from 'vue';
export default Vue;
